import { toRelativeUrl } from "@okta/okta-auth-js";
import { LoginCallback, Security } from "@okta/okta-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Route, Routes, useNavigate } from "react-router-dom";
import { oktaAuth } from "@/auth/okta";
import { RequiresAccess } from "@/components/RequiresAccess";
import { RequiresAuth } from "@/components/RequiresAuth";
import { Spinner } from "@/components/ui";
import BoxInvitesPage from "@/pages/BoxInvitesPage";
import FoldersPage from "@/pages/FoldersPage";
import HealthPage from "@/pages/HealthPage";
import HistoryPage from "@/pages/HistoryPage";
import RecipientsPage from "@/pages/RecipientsPage";
import ReportsPage from "@/pages/ReportsPage";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

export default function App() {
  const navigate = useNavigate();
  const restoreOriginalUri = (_: unknown, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route
            path="/oauth/okta"
            element={<LoginCallback loadingElement={<Spinner />} />}
          />
          <Route element={<RequiresAuth />}>
            <Route element={<RequiresAccess />}>
              <Route index element={<HealthPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="recipients" element={<RecipientsPage />} />
              <Route path="folders" element={<FoldersPage />} />
              <Route path="box-invites" element={<BoxInvitesPage />} />
              <Route path="history" element={<HistoryPage />} />
            </Route>
          </Route>
        </Routes>
      </QueryClientProvider>
    </Security>
  );
}
